var map = {
	"./isomorphic/environmentConfiguration": 487,
	"./sony/trilithium/environmentConfiguration": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;


//////////////////
// WEBPACK FOOTER
// ./src/services/platforms ^\.\/.*\/environmentConfiguration$
// module id = 486
// module chunks = 0